export default {
    namespaced: true,
    state: {
        intro_section: true
    },
    getters: {
        introSection: state => state.intro_section
    },
    mutations: {
        introSectionMutate(state, data) {
            state.intro_section = data;
        }
    },
    actions: {
        setIntroSection(context, data) {
            context.commit('introSectionMutate', data)
        }
    }
}